import React from 'react';
import { Link } from 'src/components/Inputs';

/*
 * When making changes to this file be sure that any changes
 * also are made to the corresponding iOS specific counterpart
 * in src/pages/<lang>/legal/ios.jsx.
 */

const EWRDEEndUserServicesAgreement = () => {
  return (
    <>
      <h4
        id='end-user-services-agreement-ewr-de'
        data-magellan-target='end-user-services-agreement-ewr-de'
      >
        Vereinbarung über Endnutzerdienste (EWR)
      </h4>
      <p>Letzte Aktualisierung: 04. April 2022</p>
      <p>Vielen Dank, dass Sie Plaid nutzen!</p>
      <p>
        Diese Vereinbarung über Endnutzerdienste (die „
        <strong>Vereinbarung</strong>“) ist eine rechtliche Vereinbarung
        zwischen Plaid, BV („<strong>Plaid</strong>“, „<strong>wir</strong>“
        oder „<strong>uns</strong>“) und dem Endnutzer unserer Dienste („
        <strong>Sie</strong>“, „<strong>Ihr</strong>“). Diese Vereinbarung gilt
        nur, wenn wir Ihnen Kontoinformationsdienste und Zahlungsauslösedienste
        (im Sinne der überarbeiteten europäischen Zahlungsdiensterichtlinie (EU)
        2015/2366) in Bezug auf ein niederländisches Zahlungskonto oder ein
        Zahlungskonto im Europäischen Wirtschaftsraum (EWR) erbringen und wenn
        wir die abgerufenen Daten und/oder den Zahlungsstatus im Zusammenhang
        mit diesen Diensten in Ihrem Namen an Dritte übermitteln (die „
        <strong>Dienste</strong>“). Diese Dritten umfassen den Eigentümer oder
        Anbieter der Website, Desktop- und/oder mobilen Anwendung, über die Sie
        auf unsere Dienste zugegriffen haben (die „<strong>Anwendung</strong>“).
      </p>
      <p>
        Diese Vereinbarung beschreibt die Bedingungen, die für Ihre Nutzung der
        Dienste gelten. Der Zugriff auf die Dienste und deren Nutzung ist nur
        dann gestattet, wenn Sie sich mit allen Bestimmungen und Bedingungen
        dieser Vereinbarung einverstanden erklären. Aus diesem Grund sollten Sie
        diese Vereinbarung sorgfältig lesen und sich davon überzeugen, dass Sie
        sie verstehen. Wenn Sie eine der Bedingungen dieser Vereinbarung nicht
        verstehen, nehmen Sie bitte Kontakt mit uns auf, bevor Sie die Dienste
        nutzen, indem Sie uns eine E-Mail an{' '}
        <Link href='mailto:regulatory@plaid.com'>
          <a>regulatory@plaid.com</a>
        </Link>{' '}
        senden.
      </p>
      <p>
        Eine aktuelle Kopie dieser Vereinbarung können Sie jederzeit unter{' '}
        <Link href='https://plaid.com/legal/'>
          <a>https://plaid.com/legal/</a>
        </Link>{' '}
        aufrufen.
      </p>
      <p>
        <em>Zum Abschnitt springen:</em>
      </p>
      <p>
        <Link href='#plaid-de'>
          <a data-smooth-scroll data-offset='80'>
            Plaid
          </a>
        </Link>
      </p>
      <p>
        <Link href='#plaid-dienste-de'>
          <a data-smooth-scroll data-offset='80'>
            Plaid-Dienste
          </a>
        </Link>
      </p>
      <p>
        <Link href='#anspruchsberechtigung-und-verfugbarkeit-de'>
          <a data-smooth-scroll data-offset='80'>
            Anspruchsberechtigung und Verfügbarkeit
          </a>
        </Link>
      </p>
      <p>
        <Link href='#kommunikation-de'>
          <a data-smooth-scroll data-offset='80'>
            Kommunikation
          </a>
        </Link>
      </p>
      <p>
        <Link href='#daten-de'>
          <a data-smooth-scroll data-offset='80'>
            Daten
          </a>
        </Link>
      </p>
      <p>
        <Link href='#haftung-de'>
          <a data-smooth-scroll data-offset='80'>
            Haftung
          </a>
        </Link>
      </p>
      <p>
        <Link href='#beschwerden-de'>
          <a data-smooth-scroll data-offset='80'>
            Beschwerden
          </a>
        </Link>
      </p>
      <p>
        <Link href='#anderungen-an-dieser-vereinbarung-de'>
          <a data-smooth-scroll data-offset='80'>
            Änderungen an dieser Vereinbarung
          </a>
        </Link>
      </p>
      <p>
        <Link href='#kundigung-de'>
          <a data-smooth-scroll data-offset='80'>
            Kündigung
          </a>
        </Link>
      </p>
      <p>
        <Link href='#anwendbares-recht-und-sprache-de'>
          <a data-smooth-scroll data-offset='80'>
            Anwendbares Recht und Sprache
          </a>
        </Link>
      </p>
      <p id='plaid-de'>
        <strong>1. Plaid</strong>
      </p>
      <p>
        1.1. Plaid, BV (RSIN 860002652) ist von der De Nederlandsche Bank N.V.
        für die Bereitstellung von Kontoinformationsdiensten (AIS) lizenziert
        und bei der De Nederlandsche Bank N.V. unter der Nummer R179714
        registriert.
      </p>
      <p>
        1.2. Der eingetragene Sitz von Plaid ist Muiderstraat 1, 1011PZ
        Amsterdam, Niederlande. Die Handelsadresse von Plaid lautet Suite 3A03,
        Singel 542, 1017AZ, Amsterdam, Niederlande.
      </p>

      <p id='plaid-dienste-de'>
        <strong>2. Plaid-Dienste</strong>
      </p>
      <p>
        2.1. Sie haben über eine Anwendung oder über das Plaid-Dashboard
        (verfügbar unter{' '}
        <Link href='https://my.plaid.com/'>
          <a>https://my.plaid.com/</a>
        </Link>
        ) auf unsere Dienste zugegriffen. Die Ihnen über die Anwendung zur
        Verfügung gestellten Produkte und Dienstleistungen werden durch einen
        separaten Vertrag zwischen Ihnen und dem Anbieter der Anwendung (die „
        <strong>Anwendungsbedingungen</strong>“) geregelt. Wir tragen keine
        Verantwortung für die Produkte und Dienstleistungen, die Ihnen durch
        oder über die Anwendung zur Verfügung gestellt werden, und haften Ihnen
        gegenüber nicht für Schäden oder Verluste, die sich aus Ihrer Nutzung
        dieser Produkte und Dienstleistungen ergeben
      </p>
      <p>
        2.2. Mit unseren Diensten können Sie Finanzinformationen von Ihrem
        Online-Bank- oder Zahlungskonto (das „<strong>Zahlungskonto</strong>“)
        abrufen (Kontoinformationsdienste).
      </p>
      <p>
        2.3. Die Geschäftsbedingungen, die für die Zahlungskonten gelten, auf
        die Sie über unsere Dienste zugreifen (die „
        <strong>Kontobedingungen</strong>
        “), bleiben in Kraft und die vorliegenden Vertragsbedingungen ändern
        Ihre Kontobedingungen nicht.
      </p>
      <p>
        2.4. Wir stellen Ihnen keine Gebühren für die Nutzung unserer Dienste in
        Rechnung. Es ist jedoch möglich, dass Anwendungen oder andere Dritte
        Ihnen Produkte und Dienste berechnen, die Ihnen unter Nutzung der von
        Plaid im Rahmen dieses Vertrags bereitgestellten Dienste zur Verfügung
        gestellt werden. Die Anbieter von Anwendungen und andere Dritte können
        uns Gebühren und andere Beträge im Zusammenhang mit den von uns für sie
        erbrachten Diensten zahlen.
      </p>
      <p>
        <span style={{ textDecoration: 'underline' }}>
          Kontoinformationsdienste
        </span>
      </p>
      <p>
        2.5. Die Kontoinformationsdienste von Plaid ermöglichen Ihnen den
        Zugriff und die Anzeige von Informationen zu Ihrem ausgewählten
        Zahlungskonto innerhalb des Plaid-Dashboards (verfügbar unter{' '}
        <Link href='https://my.plaid.com/'>
          <a>https://my.plaid.com/</a>
        </Link>
        ) und der Anwendung, über die Sie auf unsere Dienste zugegriffen haben.
      </p>
      <p>
        2.6. Um auf das Plaid-Dashboard zugreifen zu können, müssen Sie ein
        Konto bei Plaid erstellen. Darüber hinaus müssen Sie sich davon
        überzeugen, dass Ihre Angaben richtig, vollständig und aktuell sind.
        Befolgen Sie die bewährten Verfahren zur Sicherung Ihres Plaid-Kontos
        und informieren Sie uns, wenn Sie von einem unbefugten Zugriff auf Ihr
        Plaid-Konto oder dessen Nutzung erfahren.
      </p>
      <p>
        2.7. Sofern Sie ausdrücklich zugestimmt haben, greifen wir auf
        Informationen zu Ihrem ausgewählten Zahlungskonto oder -konten (die „
        <strong>Kontoinformationen</strong>“) innerhalb des Plaid-Dashboards zu,
        zeigen diese an und übermitteln diese Informationen an die Anwendung,
        über die Sie auf unsere Dienste zugegriffen haben. Dazu können folgende
        Informationen gehören:
      </p>
      <p>
        (a) Verlauf der Finanztransaktionen, z. B. Transaktionsbetrag, Daten,
        Beschreibung und Währung
      </p>
      <p>
        (b) Finanzkontodaten, z. B. Kontonummer, Kontotyp, Währung und Saldo und
      </p>
      <p>
        (c) Informationen über den Inhaber eines Finanzkontos, z. B. Name,
        Adresse, Telefonnummer und E-Mail-Adresse
      </p>
      <p>
        2.8. Vor Erhalt des Kontoinformationsdienstes von Plaid werden Sie die
        Anwendung, über die Sie auf unsere Dienste zugegriffen haben, angewiesen
        haben, Ihre Kontoinformationen über Plaid abzurufen. Nach dieser
        Anweisung werden Sie in der Regel zu uns weitergeleitet.
      </p>
      <p>
        2.9. Nach der Weiterleitung zu uns werden wir Sie bitten, den Anbieter
        des Zahlungskontos auszuwählen (der „<strong>Kontoanbieter</strong>“),
        von dem wir die Kontoinformationen abrufen sollen. Sie erklären sich
        ausdrücklich damit einverstanden, dass wir: (i) Ihre Kontoinformationen
        von dem von Ihnen ausgewählten Kontoanbieter abrufen; und (ii) die in
        Ziffer 2.12 dieser Vereinbarung beschriebenen Schritte unternehmen,
        sobald wir Ihre Kontoinformationen abgerufen haben. Plaid wird Ihre
        Kontodaten in regelmäßigen Abständen entsprechend Ihrer Zustimmung von
        Ihrem Kontoanbieter anfordern, bis die Zustimmung abläuft oder
        zurückgenommen wird.
      </p>
      <p>
        2.10. Wir weisen Sie darauf hin, dass Sie unter Umständen auf die
        Website oder die mobile Anwendung Ihres Kontoanbieters weitergeleitet
        werden, um sich zu authentifizieren, damit Ihr Kontoanbieter weiß, dass
        Sie dem Zugriff auf Ihre Kontodaten zustimmen.
      </p>
      <p>
        2.11. Alternativ dazu können wir Sie unter bestimmten Umständen bitten,
        uns die Anmeldedaten für Ihr Zahlungskonto anzugeben. Wenn Sie uns die
        Anmeldedaten für Ihr Zahlungskonto mitteilen, bestätigen Sie, dass Sie
        über alle erforderlichen Rechte, Berechtigungen und Befugnisse verfügen,
        um uns Ihre Anmeldedaten und Kontoinformationen mitzuteilen, und Sie
        geben uns die ausdrückliche Erlaubnis, Ihre Anmeldedaten für den Zugriff
        auf Ihr Zahlungskonto zu verwenden, um in Ihrem Namen und auf Ihre
        Anweisung die erforderlichen Kontoinformationen einzuholen, damit wir
        Ihnen die Dienste zur Verfügung stellen können.
      </p>
      <p>
        2.12. Nachdem wir auf Ihre Kontoinformationen zugegriffen haben, können
        wir:
      </p>
      <p>
        (a) Ihre Kontoinformationen an die Anwendung weitergeben, über die Sie
        auf unsere Dienste zugegriffen haben
      </p>
      <p>
        (b) Ihre Kontoinformationen auf Anweisung der Anwendung, über die Sie
        auf unsere Dienste zugegriffen haben, an Dritte weitergeben,
        vorausgesetzt, Sie haben der Weitergabe ausdrücklich zugestimmt oder
      </p>
      <p>(c) Ihre Kontoinformationen auf dem Dashboard von Plaid anzeigen.</p>
      <p>
        2.13. Sie erklären sich damit einverstanden, dass wir die
        Kontoinformationen, auf die wir von Ihrem Kontoanbieter zugegriffen
        haben, an die Anwendung, über die Sie auf unsere Dienste zugegriffen
        haben, und an Dritte weitergeben, wie von dieser Anwendung angewiesen,
        vorausgesetzt, dass Sie in beiden Fällen ausdrücklich in die Weitergabe
        eingewilligt haben. Durch diese Weitergabe kann die Anwendung Ihnen
        Produkte und Dienstleistungen im Einklang mit den Anwendungsbedingungen
        zur Verfügung stellen.
      </p>
      <p>
        2.14. Wir überprüfen die Richtigkeit der von Ihrem Kontoanbieter
        abgerufenen Kontoinformationen nicht und verlassen uns darauf, dass Ihr
        Kontoanbieter die Richtigkeit und Aktualität Ihrer Kontoinformationen
        sicherstellt.
      </p>
      <p>
        2.15. Wir können Ihre Kontoinformationen standardisieren,
        kategorisieren, zusammenlegen, aggregieren und anderweitig verarbeiten,
        bevor wir Ihre Kontoinformationen auf dem Plaid-Dashboard anzeigen, sie
        an die Anwendung weitergeben, über die Sie auf unsere Dienste
        zugegriffen haben, oder sie auf Anweisung dieser Anwendung mit Ihrer
        ausdrücklichen Zustimmung an Dritte weitergeben.
      </p>
      <p>
        2.16. Sie haben jederzeit die Möglichkeit, Ihre Zustimmung zur
        Bereitstellung von Kontoinformationsdiensten durch Plaid zu widerrufen
        oder zu ändern.
      </p>
      <p id='anspruchsberechtigung-und-verfugbarkeit-de'>
        <strong>3. Anspruchsberechtigung und Verfügbarkeit</strong>
      </p>
      <p>3.1. Sie dürfen die Dienste nur nutzen, wenn:</p>
      <p>(a) Sie 18 Jahre oder älter sind</p>
      <p>
        (b) Ihr Zahlungskonto und Ihr Kontoanbieter ihren Sitz in den
        Niederlanden oder einem anderen Land des EWR haben
      </p>
      <p>
        (c) Sie uns genaue, vollständige und aktuelle Informationen
        bereitstellen und keine falschen Angaben zu Ihrer Identität oder anderen
        Informationen über Sie machen
      </p>
      <p>
        (d) Sie sich mit dieser Vereinbarung und mit der Nutzung unserer Dienste
        gemäß dieser Vereinbarung einverstanden erklären und
      </p>
      <p>
        (e) Sie sich verpflichten, alle Gesetze und Vorschriften zu befolgen,
        die für Ihre Nutzung der Dienste gelten
      </p>
      <p>
        3.2. Die angebotenen Dienste und die Art und Weise, in der die Dienste
        erbracht werden, können je nach dem von Ihnen verwendeten Gerätetyp, der
        Art Ihres Zahlungskontos bzw. Ihrer Zahlungskontos, den Kontobedingungen
        und den Anwendungsbedingungen variieren.
      </p>

      <p id='kommunikation-de'>
        <strong>4. Kommunikation</strong>
      </p>
      <p>
        4.1. Sofern Plaid dies für angemessen hält, kann Plaid Ihnen
        Informationen und Benachrichtigungen per SMS an Ihre E-Mail-Adresse oder
        Ihre Handynummer senden.
      </p>
      <p>
        4.2. Wenn sich Ihre Kontaktdaten (einschließlich Ihrer Handynummer oder
        E-Mail-Adresse) ändern, teilen Sie uns dies bitte so schnell wie möglich
        mit. Sie sind dafür verantwortlich, Ihr Handy oder Ihren
        E-Mail-Posteingang regelmäßig auf Informationen und Benachrichtigungen
        von Plaid zu überprüfen.
      </p>
      <p>
        4.3. Sie können sich mit Plaid in Verbindung setzen, indem Sie uns eine
        E-Mail an{' '}
        <Link href='mailto:regulatory@plaid.com'>
          <a>regulatory@plaid.com</a>
        </Link>{' '}
        senden.
      </p>

      <p id='daten-de'>
        <strong>5. Daten</strong>
      </p>
      <p>
        5.1. Wir verwenden Ihre Daten im Einklang mit unserer
        Datenschutzrichtlinie für Endnutzer (die „
        <strong>Datenschutzrichtlinie</strong>“), die Sie auf unserer Website
        unter{' '}
        <Link href='https://plaid.com/legal/#end-user-privacy-policy'>
          <a>https://plaid.com/legal/#end-user-privacy-policy</a>
        </Link>{' '}
        abrufen können. Wenn Sie nicht damit einverstanden sind, wie wir mit
        Ihren Daten umgehen, so wie es in der Datenschutzrichtlinie erläutert
        wird, sollten Sie unseren Dienst nicht nutzen.
      </p>

      <p id='haftung-de'>
        <strong>6. Haftung</strong>
      </p>
      <p>
        6.1. Für Verluste, die durch Umstände verursacht werden, die außerhalb
        unserer Kontrolle liegen, wie z. B. extreme Wetterbedingungen,
        terroristische Aktivitäten oder Arbeitskämpfe, übernimmt Plaid keine
        Haftung.
      </p>
      <p>
        6.2. Plaid haftet nicht für einen Verstoß gegen eine Auflage, die ihm
        durch oder gemäß den geltenden niederländischen Finanzgesetzen und
        -vorschriften vorgeschrieben ist, wenn der Verstoß auf Folgendes
        zurückzuführen ist:
      </p>
      <p>
        (a) ungewöhnliche oder unvorhersehbare Umstände, die nicht von Plaid zu
        vertreten sind und deren Folgen trotz aller Bemühungen unvermeidbar
        gewesen wären, oder
      </p>
      <p>
        (b) Verpflichtungen von Plaid gemäß anderen Bestimmungen des EU- oder
        nationalen Rechts
      </p>
      <p>
        6.3. Unsere Haftung für folgende Fälle wird weder ausgeschlossen noch
        beschränkt:
      </p>
      <p>
        (a) Tod oder Personenschaden, der durch unsere Fahrlässigkeit verursacht
        wurde
      </p>
      <p>(b) Betrug oder arglistige Täuschung unsererseits oder</p>
      <p>
        (c) eine vorsätzliche Verletzung dieser Vereinbarung in wesentlicher
        Weise, die darauf abzielt, Ihnen zu schaden
      </p>
      <p>
        6.4. Wir übernehmen keine Haftung für Schäden oder Verluste, die Ihnen
        durch Handlungen oder Unterlassungen Dritter entstehen, insbesondere
        Ihres Kontoanbieters bzw. Ihrer Kontoanbieter und der Anwendung, über
        die Sie auf unsere Dienste zugegriffen haben.
      </p>

      <p id='beschwerden-de'>
        <strong>7. Beschwerden</strong>
      </p>
      <p>
        7.1. Wenn Sie sich über unsere Dienste beschweren möchten, senden Sie
        uns bitte eine E-Mail an{' '}
        <Link href='mailto:regulatory@plaid.com'>
          <a>regulatory@plaid.com,</a>
        </Link>
        , damit Plaid den Sachverhalt für Sie untersuchen kann. Wir werden
        versuchen, Ihre Beschwerden über unsere Dienste schnell und fair im
        Einklang mit unseren Verpflichtungen nach dem anwendbaren Recht zu
        bearbeiten. Plaid kann Sie jedoch an folgende Stellen verweisen:
      </p>
      <p>
        (a) Ihren Kontoanbieter, falls sich Ihre Beschwerde auf die Dienste
        bezieht, die im Rahmen der Kontobedingungen erbracht werden, oder
      </p>
      <p>
        (b) die Anwendung, über die Sie auf unsere Dienste zugegriffen haben,
        falls sich Ihre Beschwerde auf die Produkte und/oder Dienstleistungen
        bezieht, die über die Anwendung gemäß den Anwendungsbedingungen
        bereitgestellt werden.
      </p>
      <p>
        7.2. Wenn sich Ihre Beschwerde auf unsere Dienste bezieht und wir keine
        Lösung finden, können Sie sich innerhalb von drei Monaten nach Zugang
        unserer endgültigen Antwort auf die Beschwerde oder innerhalb eines
        Jahres, nachdem Sie Ihre Beschwerde bei uns eingereicht haben, an die
        Beschwerdestelle für Finanzdienstleistungen (
        <em>Klachteninstituut financiële dienstverlening – KiFiD</em>) wenden.
        Die Beschwerdestelle für Finanzdienstleistungen erreichen Sie montags
        bis freitags von 9 bis 19 Uhr und samstags von 9 bis 13 Uhr telefonisch
        unter +3170 333 89 99, auf dem Postwege: KiFiD, Postbus 93257, 2509 AG
        Den Haag, Niederlande, oder per E-Mail:{' '}
        <Link href='mailto:consumenten@kifid.nl'>
          <a>consumenten@kifid.nl</a>
        </Link>
        . Plaid ist bei der Beschwerdestelle für Finanzdienstleistungen unter
        der Nummer R179714 registriert. Sie haben auch das Recht, Ihre
        Beschwerde direkt bei einem der zuständigen Zivilgerichte in den
        Niederlanden einzureichen.
      </p>
      <p>
        7.3. Plaid ist ferner nicht verantwortlich für Beschwerden oder
        Streitigkeiten über Produkte und/oder Dienstleistungen, die von der
        Anwendung, über die Sie auf unsere Dienste zugegriffen haben, von
        anderen Dritten oder von Ihrem Kontoanbieter geliefert werden. Diese
        sollten Sie direkt mit der Anwendung, dem Dritten oder dem Kontoanbieter
        klären.
      </p>

      <p id='anderungen-an-dieser-vereinbarung-de'>
        <strong>8. Änderungen an dieser Vereinbarung</strong>
      </p>
      <p>
        8.1. Plaid behält sich das Recht vor, diese Vereinbarung jederzeit zu
        ändern. Wir werden Ihre Interessen, die von den beabsichtigten
        Änderungen betroffen sind, berücksichtigen und nur Änderungen vornehmen,
        die wir für angemessen halten.
      </p>
      <p>
        8.2. Wir teilen Ihnen jede beabsichtigte wesentliche Änderung dieser
        Vereinbarung zusammen mit der neuen Version der Vereinbarung mindestens
        zwei Monate im Voraus schriftlich über die Kontaktdaten mit, die Sie uns
        übermittelt haben.
      </p>
      <p>
        8.3. Wenn Sie mit einer vorgeschlagenen Änderung nicht einverstanden
        sind, informieren Sie uns bitte über die in Ziffer 4.3 genannten
        Kontaktdaten von Plaid, bevor die Änderung in Kraft tritt. Sie haben
        dann das Recht, diese Vereinbarung jederzeit vor dem vorgesehenen Datum
        des Inkrafttretens der Änderung zu kündigen. Setzen Sie sich nicht mit
        uns in Verbindung, um uns mitzuteilen, dass Sie die Änderungen ablehnen
        und diese Vereinbarung kündigen möchten, wird davon ausgegangen, dass
        Sie die Änderungen der Vereinbarung akzeptiert haben.
      </p>

      <p id='kundigung-de'>
        <strong>9. Kündigung</strong>
      </p>
      <p>
        9.1. Das Vertragsverhältnis zwischen Ihnen und Plaid, das in dieser
        Vereinbarung dargelegt ist und Ihre Nutzung der Dienste regelt, bleibt
        bis zur Kündigung gemäß dieser Ziffer 9 bestehen.
      </p>
      <p>
        9.2. Sie haben das Recht, das in dieser Vereinbarung festgelegte
        Vertragsverhältnis zwischen Ihnen und Plaid jederzeit fristlos zu
        kündigen, indem Sie Plaid über die in Ziffer 4.3 genannten Kontaktdaten
        von Plaid kontaktieren.
      </p>
      <p>
        9.3. Wir können das Vertragsverhältnis mit Ihnen mit sofortiger Wirkung
        durch schriftliche Erklärung kündigen:
      </p>
      <p>
        (a) wenn Sie wiederholt gegen diese Vereinbarung verstoßen und die
        Angelegenheit nicht zeitnah zur Zufriedenheit von Plaid lösen oder
      </p>
      <p>(b) im Falle Ihres Todes oder Ihrer Geschäftsunfähigkeit</p>
      <p>
        9.4. Wir sind berechtigt, diese Vereinbarung mit Ihnen mit einer Frist
        von mindestens 2 Monaten schriftlich zu kündigen.
      </p>

      <p id='anwendbares-recht-und-sprache-de'>
        <strong>10. Anwendbares Recht und Sprache</strong>
      </p>
      <p>
        10.1. Auf diese Vereinbarung und alle Streitigkeiten oder Ansprüche
        (einschließlich außervertraglicher Streitigkeiten oder Ansprüche), die
        sich aus ihr oder in Verbindung mit ihr oder ihrem Gegenstand oder ihrem
        Zustandekommen ergeben, ist ausschließlich niederländisches Recht
        anwendbar.
      </p>
      <p>
        10.2. Diese Vereinbarung ist in englischer und niederländischer Sprache
        verfügbar. Sämtliche Kommunikation mit Ihnen erfolgt in englischer
        Sprache.
      </p>

      <hr className='section-divider' />
    </>
  );
};

export default EWRDEEndUserServicesAgreement;
